const TOKEN = "access_token"
const USER = "access_user"
const MENU = "access_menu"
const FCM = "access_fcm"
const RELOAD = "access_reload"
const COMPANY = "access_company"
const COLOR = "access_color"
const COUNTER = "access_counter"
const CUSTOMER = "access_customer"
const ORDER = "access_order"

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
**/
const TokenService = {
  getToken() {
    return localStorage.getItem(TOKEN)
  },
  getUser() {
    return localStorage.getItem(USER)
  },
  getMenu() {
    return localStorage.getItem(MENU)
  },
  getFcm() {
    return localStorage.getItem(FCM)
  },
  getReload() {
    return localStorage.getItem(RELOAD)
  },
  getCompany() {
    return localStorage.getItem(COMPANY)
  },
  getColor() {
    return localStorage.getItem(COLOR)
  },
  getCounter() {
    return localStorage.getItem(COUNTER)
  },
  getCustomer() {
    return localStorage.getItem(CUSTOMER)
  },
  getOrder() {
    return localStorage.getItem(ORDER)
  },

  saveToken(accessToken, accessUser, accessMenu) {
    localStorage.setItem(TOKEN, accessToken)
    localStorage.setItem(USER, accessUser)
    localStorage.setItem(MENU, accessMenu)
  },
  updateMenu(accessMenu) {
    localStorage.setItem(MENU, accessMenu)
  },
  saveFcm(accessFcm) {
    localStorage.setItem(FCM, accessFcm)
  },
  saveReload(accessReload) {
    localStorage.setItem(RELOAD, accessReload)
  },
  saveCompany(accessCompany) {
    localStorage.setItem(COMPANY, accessCompany)
  },
  saveColor(accessColor) {
    localStorage.setItem(COLOR, accessColor)
  },
  saveCounter(accessCounter) {
    localStorage.setItem(COUNTER, accessCounter)
  },
  saveCustomer(accessCustomer) {
    localStorage.setItem(CUSTOMER, accessCustomer)
  },
  saveOrder(accessOrder) {
    localStorage.setItem(ORDER, accessOrder)
  },
  
  removeToken() {
    localStorage.removeItem(TOKEN)
    localStorage.removeItem(USER)
    localStorage.removeItem(MENU)
    localStorage.removeItem(FCM)
    localStorage.removeItem(RELOAD)
    localStorage.removeItem(COMPANY)
    localStorage.removeItem(COLOR)
    localStorage.removeItem(COUNTER)
    localStorage.removeItem(CUSTOMER)
    localStorage.removeItem(ORDER)
  }
}

export { TokenService }